
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { useToast } from '@/hooks/use-toast';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const { checkSubscription } = useSubscription();
  const { toast } = useToast();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Refresh subscription status after successful payment
    if (user && sessionId) {
      checkSubscription();
    }
  }, [user, sessionId, checkSubscription]);

  const handleContinue = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="w-full max-w-md animate-fade-in-up">
        <Card className="tesla-card text-center">
          <CardHeader className="pb-8">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-green-50 rounded-full">
                <CheckCircle className="h-16 w-16 text-green-600" />
              </div>
            </div>
            <CardTitle className="text-3xl font-bold text-black mb-2">
              Payment Successful!
            </CardTitle>
            <p className="text-gray-600 text-lg">
              Welcome to your Pro subscription
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4 text-left">
              <div className="flex items-center text-gray-700">
                <CheckCircle className="h-5 w-5 text-green-600 mr-3" />
                <span>Unlimited assessments</span>
              </div>
              <div className="flex items-center text-gray-700">
                <CheckCircle className="h-5 w-5 text-green-600 mr-3" />
                <span>Advanced analytics & insights</span>
              </div>
              <div className="flex items-center text-gray-700">
                <CheckCircle className="h-5 w-5 text-green-600 mr-3" />
                <span>Priority support</span>
              </div>
              <div className="flex items-center text-gray-700">
                <CheckCircle className="h-5 w-5 text-green-600 mr-3" />
                <span>Export to PDF</span>
              </div>
            </div>
            
            <Button 
              onClick={handleContinue}
              className="w-full tesla-accent-bg hover:bg-red-700 h-12"
            >
              Get Started
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            
            <p className="text-sm text-gray-500">
              You can manage your subscription anytime from your dashboard
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;
